// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * JSON-encoded OPC UA Variant (a method input/output argument)
 * @export
 * @interface SerializedVariant
 */
export interface SerializedVariant {
    /**
     * OPC UA DataType name (e.g. Double, String, Boolean)
     * @type {string}
     * @memberof SerializedVariant
     */
    dataType: string;
    /**
     * The argument value
     * @type {any}
     * @memberof SerializedVariant
     */
    value: any | null;
    /**
     * VariantArrayType (0 Scalar, 1 Array, 2 Matrix); Scalar when omitted
     * @type {number}
     * @memberof SerializedVariant
     */
    arrayType?: number;
}

/**
 * Check if a given object implements the SerializedVariant interface.
 */
export function instanceOfSerializedVariant(value: object): value is SerializedVariant {
    if (!('dataType' in value) || value['dataType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SerializedVariantFromJSON(json: any): SerializedVariant {
    return SerializedVariantFromJSONTyped(json, false);
}

export function SerializedVariantFromJSONTyped(json: any, ignoreDiscriminator: boolean): SerializedVariant {
    if (json == null) {
        return json;
    }
    return {
        
        'dataType': json['dataType'],
        'value': json['value'],
        'arrayType': json['arrayType'] == null ? undefined : json['arrayType'],
    };
}

export function SerializedVariantToJSON(json: any): SerializedVariant {
    return SerializedVariantToJSONTyped(json, false);
}

export function SerializedVariantToJSONTyped(value?: SerializedVariant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataType': value['dataType'],
        'value': value['value'],
        'arrayType': value['arrayType'],
    };
}

